export default "__VITE_ASSET__Cm35nBdr__"